import { createReducer } from '@reduxjs/toolkit'
import { ToastMessage } from 'primereact/toast'
import * as layoutActions from '../actions/layout'

type LayoutState = {
  loadingCounter: number
  toast?: ToastMessage
}

const initialState: LayoutState = {
  loadingCounter: 0,
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(layoutActions.startLoading, (state) => {
      state.loadingCounter += 1
    })
    .addCase(layoutActions.endLoading, (state) => {
      state.loadingCounter = Math.max(state.loadingCounter - 1, 0)
    })
    .addCase(layoutActions.showToast, (state, action) => {
      state.toast = action.payload
    })
})
